
'format es6';

import Promise from 'Promise';
import gsap from 'greensock';
import $ from 'jquery';

require('../../views-compiled/question.family');

import { factory as sectionFactory } from './Section';

const EASING = gsap.Expo;

function DomainQuestion() {

	this.templateName = 'question.family.htm';

	let data;
	let btns;
	let backlink;

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 0.1, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 0.1, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	this.setData = (vals) => {
		data = vals;
	};

	this.init = () => Promise.resolve(data);

	this.activate = () => {
		btns = $('[data-option]', this.sectionNode);
		btns.on('click.cursus', (e) => {
			e.preventDefault();
			const clicked = $(e.currentTarget);
			const val = {
				option: clicked.data('option'),
				family_id: data.famille_id,
			};
			this.animateOut().then(() => {
				this.next && this.next(val);
				this.next = null;
			});
		});
		backlink = $('.q-back a', this.sectionNode);
		backlink.on('click.cursus', (e) => {
			e.preventDefault();
			this.animateOut().then(() => {
				this.prev && this.prev();
				this.prev = null;
			});
		});
	};

	this.deactivate = () => {
		btns && btns.off('.cursus');
	};

	return this;
}


export function factory(instance) {
	return DomainQuestion.call(sectionFactory(instance || {}));
}
